import { FilterCategoryV2, FilterFieldV2 } from '../models';

export function getFieldLabelFromConfig(criteriaKey: string, categories: (FilterFieldV2 | FilterCategoryV2)[]): string | null {
  const field = getFieldFromConfig(criteriaKey, categories);
  if (field) {
    return field.fullLabel || field.label;
  }
  return null;
}

export function getFieldFromConfig(criteriaKey: string, categories: (FilterFieldV2 | FilterCategoryV2)[]): FilterFieldV2 | FilterCategoryV2 | null {
  if (!criteriaKey) return null;
  for (const category of categories) {
    let field = null;
    if ((category as FilterCategoryV2)?.fields) {
      field = (category as FilterCategoryV2).fields.find((f) => f.key === criteriaKey);
    } else if ((category as FilterFieldV2).key === criteriaKey) {
      field = category;
    }
    if (field) {
      return field;
    }
  }
  return null;
}
